<ng-container *ngIf="supportedLanguages$ | async as supportedLanguages">
  <ng-container *ngIf="mainLanguages$ | async as mainLanguages">
    <ng-container *ngIf="currentLanguage$ | async as currentLanguage">
      <ng-container *ngIf="additionalLanguages$ | async as additionalLanguages">
        <button
          class="selector-toggle"
          *ngIf="mainLanguages.length < supportedLanguages.length"
          (click)="isOpen = !isOpen"
          [attr.data-analytics]="displayInHeader ? 'header_select-language' : 'footer_select-language'"
          [attr.data-cy]="'language-selection-header'"
          [class.in-header]="displayInHeader"
          [ngClass]="{ 'chevron-down': !isOpen, 'chevron-up': isOpen }"
        >
          {{
            currentLanguage === 'ch' || !displayInHeader
              ? FRONTEND_LANGUAGE_LABELS[currentLanguage]
              : (currentLanguage | uppercase)
          }}
        </button>

        <ssc-popup (closed)="isOpen = false" [isOpen]="isOpen" popupStyle="wide" [hasHeader]="false" class="popup">
          <ng-container ngProjectAs="content">
            <div class="lists">
              <div class="main-list">
                {{ 'LANGUAGE_SELECTOR.MAIN' | translate }}
                <ul>
                  <li *ngFor="let language of mainLanguages">
                    <a
                      class="main-language"
                      (click)="changeLanguage(language)"
                      [class.active]="currentLanguage === language"
                      data-analytics="footer_select-language"
                      [attr.data-cy]="'language-button_' + language"
                    >
                      {{ FRONTEND_LANGUAGE_LABELS[language] | titlecase }}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="additional-list">
                {{ 'LANGUAGE_SELECTOR.ADDITIONAL' | translate }}
                <ul class="split-list">
                  <li *ngFor="let language of additionalLanguages">
                    <a
                      (click)="changeLanguage(language)"
                      [class.active]="currentLanguage === language"
                      data-analytics="footer_select-language"
                      [attr.data-cy]="'language-button_' + language"
                    >
                      {{ FRONTEND_LANGUAGE_LABELS[language] | titlecase }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
        </ssc-popup>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
